var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.47931 0.82835C4.04616 0.986064 2.74673 1.53121 1.62559 2.86492C-1.40527 6.46492 0.0587341 10.3084 4.61188 11.0318C7.26559 11.4535 6.50788 12.5472 5.63702 12.8044C5.28388 12.9072 5.27702 13.0409 5.61302 13.1369C7.12845 13.5586 12.4016 10.7095 11.925 5.93692C11.7262 3.93121 10.8587 2.55978 9.29188 1.76778C8.64045 1.43864 8.56502 1.59635 9.19931 1.97006C9.68616 2.25464 10.1593 2.67635 10.4644 3.09464C10.9822 3.80778 11.3387 4.79178 11.4244 5.75521C11.6713 8.56321 10.0804 11.0352 7.82788 12.1632C7.59131 12.2798 6.76159 12.6261 6.71359 12.6261C6.66902 12.6261 7.59131 11.2238 5.11931 10.8604C3.89531 10.6786 3.37759 10.5484 2.76731 10.2604C0.62102 9.24892 0.0347345 6.90721 1.29645 4.39749C2.87702 1.25349 5.24616 0.944921 7.58102 1.39749C8.29416 1.53464 8.36959 1.34606 7.64959 1.13006C6.83016 0.87635 6.03473 0.766636 5.47931 0.82835Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.80fe4e48.svg";
export { ForwardRef as ReactComponent };